import React from 'react';
import { Wheat, Map, Briefcase, Clock, CreditCard, Users } from 'lucide-react';

const FarmParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  farmTypes,
  regions,
  organizationTypes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Размер фермерского хозяйства */}
      <div>
        <label htmlFor="farmSize" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Wheat className="w-4 h-4 mr-2 text-emerald-500" />
          Размер хозяйства (га)
        </label>
        <input
          type="text"
          id="farmSize"
          name="farmSize"
          value={formData.farmSize}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.farmSize ? 'input-error' : ''}`}
          placeholder="Введите площадь в гектарах"
        />
        {errors.farmSize && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.farmSize}
          </p>
        )}
      </div>

      {/* Тип фермерского хозяйства */}
      <div>
        <label htmlFor="farmType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип сельхозпредприятия
        </label>
        <select
          id="farmType"
          name="farmType"
          value={formData.farmType}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {farmTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.farmType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.farmType}
          </p>
        )}
      </div>

      {/* Регион */}
      <div>
        <label htmlFor="regionCode" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Map className="w-4 h-4 mr-2 text-emerald-500" />
          Регион 
        </label>
        <select
          id="regionCode"
          name="regionCode"
          value={formData.regionCode}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {regions.map((region) => (
            <option key={region.code} value={region.code}>
              {region.name}
            </option>
          ))}
        </select>
        {errors.regionCode && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.regionCode}
          </p>
        )}
      </div>

      {/* Тип организации */}
      <div>
        <label htmlFor="organizationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Briefcase className="w-4 h-4 mr-2 text-emerald-500" />
          Организационно-правовая форма
        </label>
        <select
          id="organizationType"
          name="organizationType"
          value={formData.organizationType}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {organizationTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.organizationType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.organizationType}
          </p>
        )}
      </div>

      {/* Опыт ведения сельского хозяйства */}
      <div>
        <label htmlFor="farmingExperience" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Clock className="w-4 h-4 mr-2 text-emerald-500" />
          Опыт в сельском хозяйстве (лет)
        </label>
        <input
          type="text"
          id="farmingExperience"
          name="farmingExperience"
          value={formData.farmingExperience}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.farmingExperience ? 'input-error' : ''}`}
          placeholder="Введите количество лет опыта"
        />
        {errors.farmingExperience && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.farmingExperience}
          </p>
        )}
      </div>

      {/* Годовая выручка */}
      <div>
        <label htmlFor="annualRevenue" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-emerald-500" />
          Годовая выручка (руб.)
        </label>
        <input
          type="text"
          id="annualRevenue"
          name="annualRevenue"
          value={formData.annualRevenue}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.annualRevenue ? 'input-error' : ''}`}
          placeholder="Введите сумму выручки за год"
        />
        {errors.annualRevenue && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.annualRevenue}
          </p>
        )}
      </div>

      {/* Количество сотрудников */}
      <div>
        <label htmlFor="employeeCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Users className="w-4 h-4 mr-2 text-emerald-500" />
          Количество сотрудников
        </label>
        <input
          type="text"
          id="employeeCount"
          name="employeeCount"
          value={formData.employeeCount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.employeeCount ? 'input-error' : ''}`}
          placeholder="Введите количество сотрудников"
        />
        {errors.employeeCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.employeeCount}
          </p>
        )}
      </div>

      {/* Период программы субсидирования */}
      <div>
        <label htmlFor="programDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Clock className="w-4 h-4 mr-2 text-emerald-500" />
          Период программы (лет)
        </label>
        <input
          type="text"
          id="programDuration"
          name="programDuration"
          value={formData.programDuration}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.programDuration ? 'input-error' : ''}`}
          placeholder="Введите срок программы"
        />
        {errors.programDuration && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.programDuration}
          </p>
        )}
      </div>

      {/* Дата начала программы */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Дата начала программы
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>
    </div>
  );
};

export default FarmParametersSection;